export * from './ProductPageResponsive'
